import styled, { css } from 'styled-components';
import { ClearFix, VisuallyHidden } from '../../../utils.styles';
import { PlayLinkContainer } from '../../../../components/Link';
import { device } from '../../../breakpoints';
import { PlayTextStyles } from '../../../typography/PlayText/PlayText.styles';
import { PlayPrefixTypography } from '../../../typography/PlayPrefix.styles';
import { playFontSize } from '../../../typography/helpers';
import { regularWhite, fontWeightBold } from '../../../design-tokens';

export const ContentInformation = styled.div`
    ${ClearFix}
    opacity: 1;
    word-break: break-word;
    overflow: auto;

    ${(props) =>
        props.markedAsDeleted &&
        css`
            opacity: 0;
            transition: opacity 150ms ease-in;
        `}

    ${(props) =>
        !props.hasExpanded &&
        css`
            @supports (display: -webkit-box) {
                min-height: 54px;
                overflow: hidden;
            }
        `}

        ${(props) =>
            props.hasExpanded &&
            css`
                position: relative; // Needed for accessibility text
            `}
`;

export const ContentLink = styled(PlayLinkContainer)`
    ${PlayTextStyles}
    text-decoration: none;

    @media ${device.GteSmall} {
        width: auto;
        max-width: 83%;
        float: left;

        /* backface-visibility: hidden; */
    }

    &:hover {
        cursor: pointer;
    }

    &:hover > h2 {
        text-decoration: underline;
    }
`;

export const ContentDescription = styled.span`
    ${PlayPrefixTypography}
    display: block;
    margin-bottom: 3px;
`;

export const ContentTitle = styled.h2`
    ${playFontSize(1.7)};
    display: block;
    margin-top: 10px;
    margin-bottom: 4px;
    padding-right: 10px;
    line-height: 1.2;
    color: ${regularWhite};
    font-weight: ${fontWeightBold};

    ${(props) =>
        !props.expanded &&
        css`
            @supports (display: -webkit-box) {
                max-height: 40px;
                overflow: hidden;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                /* backface-visibility: hidden; */
            }
        `}
`;

export const ToggleIcon = styled.span`
    transition: transform 0.3s;
    transform: rotate(90deg);

    ${(props) =>
        props.expanded &&
        css`
            transform: rotate(-90deg);
        `}
`;

export const ToggleExpansionButton = styled.button`
    ${playFontSize(2)};
    padding: 0;
    margin-top: 6px;
    display: none;
    overflow: hidden;

    &:focus {
        outline: 0;
        border-color: ${regularWhite};
    }

    &:hover {
        cursor: pointer;
    }

    &:active {
        border-color: transparent;
    }

    @media ${device.GteSmall} {
        display: block;
        color: ${regularWhite};
        border: 2px solid transparent;
        background: none;
        float: right;
        width: 44px;
        max-width: 17%;
        backface-visibility: hidden; // prevents icon from jumping 1px when rotating
        padding: 0;
        border-color: transparent;

        .no-js & {
            display: none;
        }
    }

    @media ${device.GteSmall} {
        display: block;
    }
`;

export const HiddenText = styled.span`
    ${VisuallyHidden}
`;
